import SearchAndCartSection from './SearchAndCartSection';
import CollectionsScreen from './CollectionsScreen';
import ProductSection from './ProductSection';

const AddCartScreen = ({
  products,
  searchValue,
  handleSearchChange,
  updateCartItems,
  updateCartItemsMulti,
  cartItems,
  updateCartVariant,
  toggleCartScreen,
  sendProductInChat,
  clearCart,
  loadMoreProducts,
  isSendInChatDisabled,
  isSearchLoading,
  shopUrl,
  shopPhoneNumber,
  shopDetailsConfig,
  detailsFromChatwoot,
  currencySymbol,
  hasMoreProducts,
  activePhoneNumber,
  selectedByCollection,
  setSelectedByCollection,
  selectedAllProducts,
  setSelectedAllProducts,
  activePanelKey,
  setActivePanelKey,
  showAllProducts,
  setShowAllProducts,
}) => {
  const cartItemQuantity = cartItems.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  // Shops that should use the previous (product-wise) display instead of collections
  const PRODUCT_VIEW_SHOP_URLS = [
    'bare-supplements.myshopify.com',
    'prashantistore.myshopify.com',
    'ugaoo-store.myshopify.com',
    'fix-my-curls.myshopify.com',
  ];
  const forceProductView = (PRODUCT_VIEW_SHOP_URLS || [])
    .map(s => (s || '').toLowerCase())
    .includes((shopUrl || '').toLowerCase());

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <SearchAndCartSection
        searchValue={searchValue}
        cartItemQuantity={cartItemQuantity}
        handleSearchChange={handleSearchChange}
        toggleCartScreen={toggleCartScreen}
        clearCart={clearCart}
      />
      <div style={{height: '95%', overflow: 'auto'}}>
        {forceProductView ? (
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <ProductSection
              products={products}
              updateCartItems={updateCartItems}
              updateCartItemsMulti={updateCartItemsMulti}
              cartItems={cartItems}
              updateCartVariant={updateCartVariant}
              sendProductInChat={sendProductInChat}
              isSendInChatDisabled={isSendInChatDisabled}
              currencySymbol={currencySymbol}
            />
            {hasMoreProducts && !isSearchLoading && (
              <button
                style={{
                  width: '100%',
                  padding: '10px',
                  border: 'none',
                  background: '#EDF6FF',
                  color: '#0954A5',
                  fontWeight: 600,
                  borderRadius: '6px',
                  cursor: 'pointer',
                }}
                onClick={loadMoreProducts}
              >
                Load More
              </button>
            )}
          </div>
        ) : (
          <CollectionsScreen
            shopUrl={shopUrl}
            shopPhoneNumber={shopPhoneNumber}
            cartItems={cartItems}
            updateCartItems={updateCartItems}
            updateCartItemsMulti={updateCartItemsMulti}
            updateCartVariant={updateCartVariant}
            sendProductInChat={sendProductInChat}
            isSendInChatDisabled={isSendInChatDisabled}
            searchValue={searchValue}
            shopDetailsConfig={shopDetailsConfig}
            detailsFromChatwoot={detailsFromChatwoot}
            currencySymbol={currencySymbol}
            activePhoneNumber={activePhoneNumber}
            selectedByCollection={selectedByCollection}
            setSelectedByCollection={setSelectedByCollection}
            selectedAllProducts={selectedAllProducts}
            setSelectedAllProducts={setSelectedAllProducts}
            activePanelKey={activePanelKey}
            setActivePanelKey={setActivePanelKey}
            showAllProducts={showAllProducts}
            setShowAllProducts={setShowAllProducts}
          />
        )}
      </div>
    </div>
  );
};

export default AddCartScreen;
